<template>
    <div class="page">
        <div class="topBox">
            <div class="topTitle">PRODUCTS</div>
            <div class="topTitle2">产品</div>
            <div class="line"></div>
        </div>
        <pageBreadcrumb :option="nav_option" />
        <div class="wrap">
            <div class="titles">{{ $route.query.title2 ? $route.query.title2 : $route.query.title }}</div>
        </div>
        <div class="listBox" v-if="list.length > 0">
            <div class="wrap">
                <div class="listFlexBox">
                    <div class="itemBox" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
                        <div class="imgBox">
                            <el-image class="img" :src="item.thumb" fit="cover"></el-image>
                            <img src="@/assets/img/productList/selectProductBg.png" class="selectProductBg" alt="" />
                        </div>
                        <div class="titleFlexBox">
                            <div class="proTitle">{{ item.title }}</div>
                            <div class="titleAddIcon"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" v-if="list.length > 0">
            <el-pagination
                class="elpagination"
                background
                layout="prev, pager, next"
                :total="count"
                :current-page="page"
                :page-size="pageNum"
                @current-change="changePage"
            >
            </el-pagination>
        </div>
        <el-empty v-if="list.length == 0" description="暂无数据..."></el-empty>
        <div class="fill100"></div>
    </div>
</template>

<script>
let that
import { mapState } from 'vuex'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'

export default {
    name: 'productListSecond',
    components: {
        pageBreadcrumb,
    },
    data() {
        return {
            nav_option: [
                { title: '首页', path: '/' },
                { title: '产品', path: '/productListFirst' },
                { title: '产品二级', path: '' },
            ],
            id: '',
            count: 0,
            page: 1,
            pageNum: 10,
            list: [],
        }
    },
    computed: {
        ...mapState([]),
    },
    watch: {
        $route: {
            immediate: false,
            deep: true,
            handler() {
                that.init()
            },
        },
    },
    created() {
        that = this
        that.init()
    },
    methods: {
        init() {
            this.id = this.$route.query.id
            if (this.$route.query.title && this.$route.query.title2) {
                this.nav_option = [
                    { title: '首页', path: '/' },
                    { title: this.$route.query.title, path: '/productListFirst' },
                    { title: this.$route.query.title2, path: '' },
                ]
            } else if (this.$route.query.title && !this.$route.query.title2) {
                this.nav_option = [
                    { title: '首页', path: '/' },
                    { title: this.$route.query.title, path: '' },
                ]
            } else if (this.$route.query.keyword != undefined) {
                this.nav_option = [
                    { title: '首页', path: '/' },
                    { title: '搜索', path: '' },
                ]
            }
            this.getList()
        },
        // 去产品详情
        goDetail(item) {
            this.$router.push({
                path: '/product-detail',
                query: {
                    id: item.inventoryId,
                },
            })
        },
        async getList() {
            let obj = {
                channelId: this.id,
                page: this.page,
                pageNum: this.pageNum,
            }
            if(this.$route.query.keyword) {
                obj['keyword'] = this.$route.query.keyword
            }
            this.$load.open()
            let res = await this.productPlistAjax(obj)
            this.$load.close()
            if (res.code == 200) {
                let { count, list } = res.data
                this.count = count
                this.list = list
            }
        },
        changePage(page) {
            this.page = page
            this.getList()
        },
        productPlistAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'product_plist',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
    },
}
</script>

<style scoped lang="less">
.topBox {
    width: 100%;
    height: 400px;
    background: url('../../assets/img/productList/topBg.png') no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    margin-bottom: 50px;

    .topTitle {
        width: 100%;
        text-align: center;
        margin-top: 100px;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        font-family: 'myTextStyle';
        margin-bottom: 23px;
    }

    .topTitle2 {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        margin-bottom: 110px;
    }

    .line {
        width: 155px;
        height: 3px;
        background: #ffffff;
        margin: 0 auto;
    }
}

.titles {
    width: 100%;
    text-align: start;
    font-weight: bold;
    font-size: 40px;
    color: #000000;
    line-height: 40px;
    margin-top: 60px;
}

.wrap {
    width: @width;
    overflow: hidden;
    margin: 0 auto;
}

.listBox {
    width: 100%;
    margin-top: 50px;

    .listFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        .itemBox {
            width: 28%;
            height: 350px;
            margin-right: 7.7%;
            margin-top: 48px;
            cursor: pointer;

            &:nth-child(-n + 3) {
                margin-top: 0;
            }

            .titleFlexBox {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .proTitle {
                    width: calc(100% - 28px - 10px);
                    font-size: 20px;
                    color: #000000;
                    line-height: 30px;
                    min-height: 30px;
                    max-height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }

                .titleAddIcon {
                    width: 28px;
                    height: 28px;
                    display: block;
                    background: url('../../assets/img/productList/add.png') no-repeat;
                    background-size: 100% 100%;
                }
            }

            &:nth-child(3n) {
                margin-right: 0;
            }

            .imgBox {
                width: 100%;
                height: 250px;
                position: relative;
                margin-bottom: 28px;

                .img {
                    width: 100%;
                    height: 250px;
                    position: relative;
                }

                .selectProductBg {
                    display: none;
                    width: 100%;
                    height: 250px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }

            &:hover {
                .selectProductBg {
                    display: block;
                }

                .proTitle {
                    color: #ff4d00;
                }

                .titleAddIcon {
                    background: url('../../assets/img/productList/add2.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
}

.elpagination {
    text-align: end;
}

.fill100 {
    width: 100%;
    height: 100px;
}
</style>
